module.exports = __webpack_public_path__ + "static/help-1c77abb62d179e4d23ef7df6b9f0a34c.png";